import { unwrapResult } from '@reduxjs/toolkit';
import { Button, Checkbox, Form, Input } from 'antd';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { postLogin } from '../auth.api';

import { handleRegister } from '../auth.reducer';


const Register = () => {
    const { loading, isRegister } = useSelector(state => state.auth)

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const onFinish = (values) => {
        console.log('Success:', values);
        dispatch(postLogin(values))
            .then(unwrapResult)
            .then(async (res) => {
                const { access_token, permissions, expires_at, roles, customer, user } = res
                await localStorage.setItem('access_token', access_token)
                await localStorage.setItem('permissions', permissions)
                // localStorage.setItem('expires_at', expires_at)
                await localStorage.setItem('roles', roles)
                await localStorage.setItem('customer', customer)
                await localStorage.setItem('user', user)

                await navigate('/home')

            })
            .catch(err => {
                console.log(err)
            })
    };
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return (
        <>
            <Form
                name="basic"
                layout="vertical"
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="on"
                disabled={loading}
            >
                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your email!',
                        },
                    ]}
                >
                    <Input type='email' />
                </Form.Item>
                <Form.Item
                    label="Nama"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: 'Silahkan masukan Nama anda!',
                        },
                    ]}
                >
                    <Input type='email' />
                </Form.Item>

                <Form.Item
                    label="Sandi"
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: 'Silahkan masukan Sandi anda!',
                        },
                    ]}
                >
                    <Input.Password />
                </Form.Item>
                <Form.Item
                    label="Konfirmasi Sandi"
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: 'Silahkan masukan Konfirmasi sandi anda!',
                        },
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" size='large' className='w-100' loading={loading}>
                        Daftar
                    </Button>
                </Form.Item>
            </Form>
            {/* <p className="text-center text-primary pointer" onClick={() => dispatch(handleRegister())}>
                {isRegister ? 'Masuk Disini!' : 'Daftar Disini!'}
            </p> */}
        </>
    );
};
export default Register;